var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"note"},[_c('FormTextarea',{staticClass:"mb-6",attrs:{"rows":5,"label":"Примечание","error":_vm.$v.model.value.$error,"errorMessage":_vm.mesErr(_vm.$v.model.value)},model:{value:(_vm.model.value),callback:function ($$v) {_vm.$set(_vm.model, "value", $$v)},expression:"model.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }